import React from 'react'
import Button from 'react-bootstrap/Button';
import './Infrastructure.css';
import Text from './Text';
import Photos from './Photos';
import Video from './Video';
const Infrastructure = () => {
  return (
    <div>
      {/* <h1>bdfgh</h1>
      <h1>bdfgh</h1> */}

    <div className="counter-wrapper3">
       <div className="counter3">
           <h1 className='count3' >Infrastructure </h1>
          
           {/* <Button > <a href="/Contact">Contact Us</a></Button> */}
       </div>
      
      
     </div>
    {/* <div className="section6">
     <div className="content-section6">
              <div className="title6">
                <h3>Welcome To Somnath International</h3>
                </div>
                <div className="content6">
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p>
              </div>
            </div>
          
          </div> */}
          <Text />
           <Photos />
           <Video />
 </div>
   
  )
}

export default Infrastructure
